import script from "./NotesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesModal.vue?vue&type=script&setup=true&lang=ts"

import "./NotesModal.vue?vue&type=style&index=0&id=4567c6b6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4567c6b6"]])

export default __exports__